module.exports = __webpack_public_path__ + "media/application/images/placeholder/placeholder-d666e2476d640300da5e0d66d6bcae38.png";